import { useSelector } from "react-redux";

function WhyCommittee() {
  // const committeeHomePage = useSelector(
  //   (x) =>
  //     x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
  //       ?.committeeHomePage
  // );
  const committeeHomePage = useSelector(
    (x) => x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
  );
  return (
    <section
      className="paragraph"
      dangerouslySetInnerHTML={{
        __html: committeeHomePage?.committeeSectionTwoDescription,
      }}
    ></section>
    // <section class="paragraph">
    //   <div class="container">
    //     <div class="row">
    //       <div class="col-md-12">
    //         <h1 class="main-title">
    //           {committeeHomePage?.committeeSectionTwoTitle}
    //         </h1>
    //         <p
    //           dangerouslySetInnerHTML={{
    //             __html: committeeHomePage?.committeeSectionTwoDescription,
    //           }}
    //         ></p>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
}

export default WhyCommittee;
